module.exports = __webpack_public_path__ + "static/img/3743_phase_function_Paper_PointsHejduk_Prediction.d93e785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3743_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kfUc
// module chunks = 0